const React = require("react");
const PT = require("prop-types");
const _ = require("lodash");
const createReactClass = require("create-react-class");
const withAnimateScroll = require("../core/hoc/withAnimateScroll");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const SetButton = require("../core/view/SetProgressButton");
const Plannings = require("./data/plannings.json");
const CarouselView = require("./CarouselView");
const AssetsUtil = require("../core/util/AssetsUtil");
const OpenBook = require("./OpenBook");
const URLMake = require("../../shared/URLMake");

const styles = require("./styles/SupportGeneral.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	Component = withOfficeErrorCatching(Component);
	Component = withAnimateScroll(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "SupportTab",

		propTypes: {
			className: PT.string,
			topic: PT.string,
			setNextScrollTo: PT.func.isRequired,
			copyFunc: PT.func.isRequired,

			// injected by HOCs
			animateScroll: PT.func.isRequired,
			dispatch: PT.func.isRequired,
			parentData: PT.object,
		},

		getInitialState: function() {
			this.linkedTopic = null;
			return {};
		},

		componentDidMount: function() {
			if (this.props.topic && this.linkedTopic) {
				this.props.setNextScrollTo(this.linkedTopic);
			}

			// Create canonical link
			const linkTag = document.createElement("link");
			linkTag.setAttribute("href", "/dashboard/support/");
			linkTag.setAttribute("rel", "canonical");
			linkTag.setAttribute("id", "canonical-support");
			document.getElementsByTagName("head")[0].appendChild(linkTag);
		},

		componentWillUnmount: function() {
			// Remove canonical link
			const linkTag = document.getElementById("canonical-support");
			if (linkTag) {
				document.getElementsByTagName("head")[0].removeChild(linkTag);
			}
		},

		componentDidUpdate: function(prevProps, prevState) {
			// Update canonical link
			if (prevProps.topic !== this.props.topic) {
				const linkTag = document.getElementById("canonical-support");
				if (linkTag) {
					linkTag.setAttribute("href", "/dashboard/support/");
				}
			}

			if (this.props.topic !== prevProps.topic) {
				//Animate scroll to the new question
				setTimeout(
					() =>
						this.props.animateScroll({
							scrollThing: this.linkedTopic,
							timeRatio: 0.65,
							maxTime: 1000,
						}),
					250
				);
			}
		},

		setButton: function(opts, text) {
			const cellSizeA = 35;
			const cellSizeB = 30;
			// Static values
			const containerDims = {
				width: 800,
				height: 600,
				left: 0,
				top: 0,
				windowWidth: 800,
				windowHeight: 600,
			};
			if (text) {
				return (
					<div className={styles.outer}>
						<div className={styles.setButtonA}>
							<SetButton
								{...opts}
								containerDims={containerDims}
								cellSize={cellSizeA}
								noPointerEvents={true}
							/>
						</div>
						<div className={styles.setButtonB}>
							<SetButton
								{...opts}
								containerDims={containerDims}
								cellSize={cellSizeB}
								noPointerEvents={true}
							/>
						</div>
						{text}
					</div>
				);
			} else {
				return (
					<div className={styles.singleButton}>
						<div className={styles.setButtonA}>
							<SetButton
								{...opts}
								containerDims={containerDims}
								cellSize={cellSizeA}
								noPointerEvents={true}
							/>
						</div>
						<div className={styles.setButtonB}>
							<SetButton
								{...opts}
								containerDims={containerDims}
								cellSize={cellSizeB}
								noPointerEvents={true}
							/>
						</div>
					</div>
				);
			}
		},

		renderSection: function(section) {
			const titleStyle = styles["title" + section.titleLevel];

			const isLinkedTopic = section.hash === this.props.topic;
			let refFunction = null;
			if (isLinkedTopic) {
				refFunction = el => {
					this.linkedTopic = el;
				};
			}

			let contents;
			if (section.hash === "sequenceDocuments") {
				contents = (
					<div className={styles.carouselWrapper}>
						<div className={styles.plannings}>
							{this.renderDocuments("sequence", false)}
						</div>
						<div className={styles.planningsWide}>
							{this.renderDocuments("sequence", true)}
						</div>
					</div>
				);
			} else if (section.hash === "standardsDocuments") {
				contents = (
					<div className={styles.carouselWrapper}>
						<div className={styles.plannings}>
							{this.renderDocuments("standards", false)}
						</div>
						<div className={styles.planningsWide}>
							{this.renderDocuments("standards", true)}
						</div>
					</div>
				);
			} else if (section.hash === "overviewDocuments") {
				contents = (
					<div className={styles.carouselWrapper}>
						<div className={styles.plannings}>
							{this.renderDocuments("overviews", false)}
						</div>
						<div className={styles.planningsWide}>
							{this.renderDocuments("overviews", true)}
						</div>
					</div>
				);
			} else if (section.hash === "placementTests") {
				contents = (
					<div className={styles.carouselWrapper}>
						<div className={styles.plannings}>
							{this.renderDocuments("placement", false)}
						</div>
						<div className={styles.planningsWide}>
							{this.renderDocuments("placement", true)}
						</div>
					</div>
				);
			} else {
				contents = section.contents;
			}

			const horizontalRule = section.horizontalRule ? (
				<hr className={styles.titleHR} />
			) : null;

			const titleEl = section.title ? (
				<div className={titleStyle} ref={refFunction}>
					{section.title}
				</div>
			) : null;

			return (
				<div className={styles.section} key={"section" + section.hash}>
					{horizontalRule}
					{titleEl}
					<div className={styles.blurb}>{contents}</div>
				</div>
			);
		},

		renderDocuments: function(type, isWide) {
			const grades = _.range(1, 6);

			const contents = grades.map(grade => {
				const pageData = _.extend(
					{planningHash: type, grade},
					_.get(Plannings, `${_.toLower(type)}.${grade}`, {})
				);
				return this.makeSinglePlanning(pageData, grade);
			});

			if (isWide) {
				return contents;
			} else {
				return (
					<CarouselView
						className={styles.carousel}
						contentEls={contents}
						key={"carouselplanning" + type}
						arrowTop={"30%"}
						arrowColor={"blue"}
						isFullWidth={false}
					/>
				);
			}
		},

		makeSinglePlanning: function(pageData, grade, isWide) {
			const hash = `planning-${pageData.planningHash}-${grade}`;
			const title = pageData.planningHash;
			const gradePlanning = (
				<img
					src={AssetsUtil.getImageForGrade(grade, "blue")}
					className={styles.chapter}
				/>
			);
			pageData.bookHash = _.toLower(title);
			const extraClass = styles.printableWithChapter;
			return (
				<div className={styles.page} key={hash} ref={hash}>
					<OpenBook
						pageData={pageData}
						type={"planning"}
						isDescriptionLink={true}
						smallDescriptions={true}
						colorScheme={"blue"}
						className={extraClass}
						hasHoverEffect={true}
					/>
					{gradePlanning}
				</div>
			);
		},

		render: function() {
			const sections = this.props.copyFunc(styles, {
				setButton: this.setButton,
				getCodes: null,
				supportType: "teacher",
				supportLinkURL: URLMake.forSchoolSupport,
			});
			const sectionEls = sections.map(section => this.renderSection(section));

			let mainClass = styles.main;
			if (this.props.className) {
				mainClass += " " + this.props.className;
			}

			return <div className={mainClass}>{sectionEls}</div>;
		},
	})
);
